module.exports = __webpack_public_path__ + "img/accept-icon.78a1990a.svg";